 
<div *ngIf="chartOpts">
  <div [attr.id]="chartContainer" style="height:300px;"></div>
</div>
<div *ngIf="!chartOpts">
   Loading---
  </div>
 